import React, { useRef } from 'react'
import { TouchableOpacity, View, TextInput as RNTextInput } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Button, ScreenAuth, Text, TextInput, ButtonSocialGroup } from '@components'
import { ScreenAuthProps } from '@navigation'
import { useLanguage } from '@context'
import { useLogin } from './hook'
import getStyle from './style'
import { getCommonStyles } from '@utils'
import { useScreen, useSocialAuth } from '@hooks'

export const Login: React.FC<ScreenAuthProps<'Login'>> = ({ navigation }) => {
  const { t } = useLanguage()

  const theme = useTheme()
  const { isMobile } = useScreen()
  const styles = getStyle(theme)
  const commonStyles = getCommonStyles(theme)

  const { email, password, isPending, error, setEmail, setPassword, handleSignIn } = useLogin()
  const { signInWithGoogle, signInWithApple, signInWithFacebook, signInWithLinkedIn } = useSocialAuth()

  const passwordRef = useRef<RNTextInput>(null)

  return (
    <ScreenAuth title={t('login.title')} isPending={isPending}>
      <View style={[styles.container, !isMobile && commonStyles.flexMaxAuth]}>
        <View>
          <TextInput
            testID="auth-email-input"
            placeholder={t('login.email')}
            value={email}
            onChangeText={setEmail}
            containerStyle={styles.emailInput}
            autoCapitalize={'none'}
            iconRight="message"
            onSubmitEditing={() => passwordRef.current?.focus()}
          />
          <TextInput
            testID="auth-password-input"
            currentRef={passwordRef}
            placeholder={t('login.password')}
            value={password}
            onChangeText={setPassword}
            iconRight="eye"
            secureTextEntry
            onSubmitEditing={handleSignIn}
          />
          {error ? (
            <Text type="bodyExtraSmall" color={theme.colors.error} style={styles.noAccount}>
              {error}
            </Text>
          ) : null}
          <TouchableOpacity onPress={() => navigation.navigate('ForgotPassword' as any)}>
            <Text type="bodyExtraSmall" color={theme.colors.black} style={styles.forgotPassowrd}>
              {t('login.forgotPassword')}
            </Text>
          </TouchableOpacity>
        </View>

        <View style={styles.buttonContainer}>
          <Button title={t('login.button')} onPress={handleSignIn} />
          <TouchableOpacity onPress={() => navigation.navigate('Register')}>
            <Text type="bodyExtraSmall" color={theme.colors.black} style={styles.noAccount}>
              {t('login.noAccount')}
            </Text>
          </TouchableOpacity>
          <ButtonSocialGroup
            title={t('login.or')}
            onPressFacebook={signInWithFacebook}
            onPressGoogle={signInWithGoogle}
            onPressApple={signInWithApple}
            onPressLinkedin={signInWithLinkedIn}
          />
        </View>
      </View>
    </ScreenAuth>
  )
}
